<div class="m-5 p-4 pb-0 pt-0">
    <div
      class="block section-label mt-[10px] mr-[78px]"
    >
      Project Type <span style="color: red; font-size: 15px">*</span>
    </div>
    <div class="autocomplete-container">
      <input
      [value]="selectedType"
        #inputFieldProjectType
        matInput
        placeholder="Select Project Type"
        [formControl]="projectTypeControl"
        (focus)="onTypeFocus()"
        (blur)="onBlur()"
        (keydown.enter)="addProjectType(inputFieldProjectType.value)"
        style="
          border-radius: 10px;
          border: 1px solid #1a4971;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          background-color: inherit;
          height: 44px;
          padding-left: 15px;
          width: 368px;
        "
      />
  
      <div class="dropdown" *ngIf="showDropdown">
        <ng-container
          *ngIf="filteredprojectTypes | async as projectTypes"
          style="width: 370px"
        >
          <div *ngIf="projectTypes.length > 0">
            <div
              *ngFor="let projectType of projectTypes"
              (click)="onSelectionTypeChange(projectType)"
              class="dropdown-item"
            >
              {{ projectType }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  
  <div class="m-5 p-4 pb-0 pt-0">
    <div
      class="block section-label mt-[10px] mr-[78px]"
    >
      Project Sub Type <span style="color: red; font-size: 15px">*</span>
    </div>
    <div class="autocomplete-container">
      <input
        [value]="selectedSubType"
        #inputFieldProjectSubType
        matInput
        placeholder="Select Project Sub Type"
        [formControl]="projectTypeControl"
        (focus)="onSubTypeFocus()"
        (blur)="onBlur()"
        (keydown.enter)="addProjectSubType(inputFieldProjectSubType.value)"
        style="
          border-radius: 10px;
          border: 1px solid #1a4971;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          background-color: inherit;
          height: 44px;
          padding-left: 15px;
          width: 368px;
        "
      />
  
      <div class="dropdown" *ngIf="showCategoryDropdown">
        <ng-container
          *ngIf="filteredprojectTypes | async as projectTypes"
          style="width: 370px"
        >
          <div *ngIf="projectTypes.length > 0">
            <div
              *ngFor="let projectType of projectTypes"
              (click)="onSelectionSubTypeChange(projectType)"
              class="dropdown-item"
            >
              {{ projectType }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>